/* tbs-ajax-filters (2026-07) - progressive enhancement for the tbs-native-filters
   sidebar. Intercepts filter / sort / per-page / pagination actions on the
   collection template and swaps section content in place via the Section
   Rendering API. Links stay plain <a>; with JS off (or on any fetch failure)
   everything falls back to full navigation.
   Sort, per-page and pagination are intercepted too because the theme's own
   AJAX reads this.currentUrl cached at section init - it goes stale after our
   pushState and would silently drop active filters. */
(function () {
  'use strict';
  if (window.__tbsAjaxFilters) return;

  var sec = document.querySelector('section[data-section-type="collection"][data-section-id]');
  if (!sec || !sec.querySelector('.collection__dynamic-part')) return;
  window.__tbsAjaxFilters = true;

  var sectionId = sec.getAttribute('data-section-id');
  var controller = null;

  history.replaceState({ tbs: 1 }, '', location.href);

  function toUrl(href) {
    return new URL(href, location.origin);
  }

  function swapFilterBlocks(doc) {
    var cur = sec.querySelectorAll('.collection__filter-group-list');
    var neu = doc.querySelectorAll('.collection__filter-group-list');
    for (var i = 0; i < cur.length; i++) {
      if (!neu[i]) continue;
      var curChips = cur[i].parentElement.querySelector('.collection__active-filters');
      var neuChips = neu[i].parentElement.querySelector('.collection__active-filters');
      if (curChips && neuChips) curChips.replaceWith(neuChips);
      else if (curChips) curChips.remove();
      else if (neuChips) cur[i].before(neuChips);
      cur[i].replaceWith(neu[i]);
    }
  }

  function updateDrawerCount() {
    var badge = sec.querySelector('.collection-drawer__filter-count');
    if (!badge) return;
    var n = sec.querySelectorAll('#mobile-collection-filters .collection__active-filter-item').length;
    badge.textContent = '(' + n + ')';
    badge.style.display = n > 0 ? 'inline' : 'none';
  }

  function scrollToTop() {
    var target = sec.querySelector('.collection') || sec;
    var cs = getComputedStyle(document.documentElement);
    var offset = (parseInt(cs.getPropertyValue('--header-is-sticky'), 10) || 0) * (parseInt(cs.getPropertyValue('--header-height'), 10) || 0);
    var top = target.getBoundingClientRect().top - 25 - offset;
    if (top < 0) window.scrollBy({ top: top, behavior: 'smooth' });
  }

  function navigate(url, push) {
    if (controller) controller.abort();
    controller = new AbortController();
    var dyn = sec.querySelector('.collection__dynamic-part');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    dyn.style.opacity = '0.4';
    dyn.style.pointerEvents = 'none';
    var fetchUrl = url.pathname + url.search + (url.search ? '&' : '?') + 'section_id=' + sectionId;
    fetch(fetchUrl, { credentials: 'same-origin', signal: controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDyn = doc.querySelector('.collection__dynamic-part');
        if (!newDyn) throw new Error('unexpected section markup');
        if (push) history.pushState({ tbs: 1 }, '', url.pathname + url.search);
        dyn.innerHTML = newDyn.innerHTML;
        dyn.style.opacity = '';
        dyn.style.pointerEvents = '';
        swapFilterBlocks(doc);
        updateDrawerCount();
        if (window.SPR) { window.SPR.initDomEls(); window.SPR.loadBadges(); }
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.dispatchEvent(new CustomEvent('tbs:collection:updated', { detail: { url: url.pathname + url.search } }));
        scrollToTop();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.assign(url.pathname + url.search);
      });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;

    var link = t.closest('.collection__filter-checkbox a[href], .collection__active-filters a[href]');
    if (link && sec.contains(link)) {
      e.preventDefault();
      var u = toUrl(link.getAttribute('href'));
      u.searchParams.delete('page');
      navigate(u, true);
      return;
    }

    var sortBtn = t.closest('#sort-by-selector [data-action="select-value"]');
    if (sortBtn) {
      e.preventDefault();
      e.stopPropagation();
      var su = toUrl(location.href);
      su.searchParams.set('sort_by', sortBtn.getAttribute('data-value'));
      su.searchParams.delete('page');
      navigate(su, true);
      return;
    }

    var dispBtn = t.closest('#display-by-selector [data-action="select-value"]');
    if (dispBtn) {
      e.preventDefault();
      e.stopPropagation();
      var du = toUrl(location.href);
      du.searchParams.delete('page');
      var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
      var proceed = function () { navigate(du, true); };
      fetch(cartUrl + '/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: { collection_products_per_page: dispBtn.getAttribute('data-value') } })
      }).then(proceed, proceed);
      return;
    }

    var pageLink = t.closest('.pagination [data-page]');
    if (pageLink && sec.contains(pageLink)) {
      e.preventDefault();
      e.stopPropagation();
      var pu = toUrl(location.href);
      var p = pageLink.getAttribute('data-page');
      if (p === '1') pu.searchParams.delete('page');
      else pu.searchParams.set('page', p);
      navigate(pu, true);
      return;
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !sec.contains(form)) return;
    if (!form.closest('.collection__filter-collapsible')) return;
    e.preventDefault();
    var u = toUrl(form.getAttribute('action') || location.pathname);
    new FormData(form).forEach(function (v, k) {
      if (v !== '') u.searchParams.append(k, v);
    });
    u.searchParams.delete('page');
    navigate(u, true);
  }, true);

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.tbs) navigate(toUrl(location.href), false);
  });
})();